<script lang="ts">
  import "../styles/app.scss";
  import "../styles/tailwind.css";
</script>
